const ARC_1_ACT_1_CUT_SCENE = {
  id: "arc-1-act-1",
  cover: {
    id: "arc-1-act-1-cover",
    image:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-1%2FArc1-Act1-Cover.png?alt=media&token=ec96a85c-f9ac-4ee7-9eb0-ec4632607f72",
    alt: "Arc 1 Act 1 cover",
  },
  pages: [
    {
      id: "page-1",
      frames: [
        {
          id: "arc-1-intro-panel",
          area: "1 / 1 / 13 / 7",
          thumbnail:
            "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-1%2Farc1-intro-thumbnail.png?alt=media&token=b41b4561-01a5-41ed-ae3c-f8d7aa5a70f8",
          image:
            "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-1%2Farc1-intro-thumbnail.png?alt=media&token=b41b4561-01a5-41ed-ae3c-f8d7aa5a70f8",
          videoUrl:
            "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-1%2Farc1-intro.mp4?alt=media&token=cdaecdbf-dace-4694-bfee-4f09c628ca80",
          alt: "Arc 1 intro panel",
          script: [
            {
              id: "arc-1-intro",
              speaker: { name: "Narrator" },
              text: "Long before Void City rose from the ashes...",
            },
          ],
        },
      ],
    },
  ],
  continuePage: {
    id: "arc-1-act-1-continue",
    label: "Enter the Arena",
    prompt: "Turn the page to begin your story.",
  },
};

export default ARC_1_ACT_1_CUT_SCENE;
export { ARC_1_ACT_1_CUT_SCENE };
